import type { ReactNode } from "react";
import styles from "./LoadingSpinner.module.scss";

export interface ILoadingSpinnerProps {
  message: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({ message, fullScreen = false }: ILoadingSpinnerProps): ReactNode {
  return (
    <div
      className={`${styles.loadingContainer} ${fullScreen ? styles.fullScreen : ""}`}
      data-testid="loading-spinner"
    >
      <div className={styles.loadingSpinner} role="status" aria-live="polite">
        <div className={styles.spinner} aria-hidden="true" />
        <p className={styles.loadingText}>{message}</p>
      </div>
    </div>
  );
}
